import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs';

import { payrollPaymentSetupComplete } from '@perpay-web/fintech/actions/payrollPaymentSetup';
import { createPayrollDeductionSuccess } from '@perpay-web/fintech/hooks/dataModule/useCreatePayrollDeductionContext';

export const payrollPaymentSetupSuccess = (action$) =>
    action$.pipe(
        ofType(createPayrollDeductionSuccess().type),
        mergeMap(() => [payrollPaymentSetupComplete()]),
    );
